import React from 'react';
import { __ } from '@wordpress/i18n';

// store
import { useCommCenter } from '../../context';

/**
 * Underline tabs of the project sidebar: Attività | Comunicazioni, plus Brief
 * where the sidebar sits next to a project. Each feed tab carries its own
 * counter — unread activities on one side, open threads on the other — so a new
 * event is visible from whichever tab is open.
 */
const CommTabs = () => {
    const {
        activeTab,
        setActiveTab,
        unreadActivityCount,
        unresolvedCommentCount,
        hasBrief,
    } = useCommCenter();

    const tabs = [
        { id: 'activities', label: __('Attività', 'soundbetween'), count: unreadActivityCount },
        { id: 'communications', label: __('Comunicazioni', 'soundbetween'), count: unresolvedCommentCount },
        ...(hasBrief ? [{ id: 'brief', label: __('Brief', 'soundbetween'), count: 0 }] : []),
    ];

    return (
        <div className={`commTabs ${tabs.length > 2 ? 'commTabs--triple' : ''}`} role="tablist">
            {tabs.map(tab => (
                <button
                    key={tab.id}
                    type="button"
                    role="tab"
                    aria-selected={activeTab === tab.id}
                    className={`commTab ${activeTab === tab.id ? 'is-active' : ''}`}
                    onClick={() => setActiveTab(tab.id)}
                    title={tab.label}>
                    <span>{tab.label}</span>
                    {tab.count > 0 && <span className="commBadge">{tab.count}</span>}
                </button>
            ))}
        </div>
    )
}

export default CommTabs;
